const LANGUAGE_REGEX = /[a-z]{2}-[A-Z]{2}/;

export const PRODUCTION_LOCALES = [
  "en-US",
  "fr-FR",
  "de-DE",
  "es-ES",
  "it-IT",
  "nb-NO",
] as const;

export const STAGING_ONLY_LOCALES = ["ja-JP"] as const;

export const ALL_LOCALES = [
  ...PRODUCTION_LOCALES,
  ...STAGING_ONLY_LOCALES,
] as const;

export function getEnabledLocales(isProduction: boolean): readonly string[] {
  return isProduction ? PRODUCTION_LOCALES : ALL_LOCALES;
}

export function getLanguageResources(enabledLocales: readonly string[]) {
  const localesModules: Record<string, { default: Record<string, unknown> }> =
    import.meta.glob("@/assets/locales/*.json", {
      eager: true,
    });
  return Object.entries(localesModules).reduce((accu, [path, translation]) => {
    const language = LANGUAGE_REGEX.exec(path)?.[0];
    if (!language || !enabledLocales.includes(language)) return accu;
    return {
      ...accu,
      [language]: {
        translation: translation.default,
      },
    };
  }, {});
}
